<template>
  <div>
    <h5>
      활동 상세
    </h5>

    <hr/>
    <div class="text-left" v-html="msg"></div>
    <hr/>
    <h5>유의사항</h5>
    <pre style="white-space: pre-wrap;"  v-text="activityNotice"></pre>
    <br>
  </div>

</template>

<script>
export default {
  name: 'ActivityDetail',
  props: {
    msg: String,
    activityNotice: String
  }
}
</script>
<style>
  #nav-tabContent  img {    max-width: 100%;}

</style>
